import React, { useEffect, useState } from "react";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import { Link, useHistory } from "react-router-dom";
import Loading from "../general/Loading";
import Unauthorized from "../general/Unauthorized";
import axios from '../../axios/axiosconf';
import { Modal, Button } from "react-bootstrap";
import CompletarDatosFactura from './CompletarDatosFactura';

function ListadoFacturas() {
    const [loggedIn, setLoggedIn] = useState(false);
    const [hasPermission, setHasPermission] = useState(false);
    const [client, setClient] = useState([]);
    const [facturas, setFacturas] = useState([]);
    const [usuarios, setUsuarios] = useState([]);
    const [pacientes, setPacientes] = useState([]);

    const history = useHistory();

    // Filtros
    const [fechaInicio, setFechaInicio] = useState('');
    const [fechaFin, setFechaFin] = useState('');
    const [usuarioFiltro, setUsuarioFiltro] = useState('');
    const [busquedaPaciente, setBusquedaPaciente] = useState('');
    const [estadoFiltro, setEstadoFiltro] = useState('');
    const [sedeFiltro, setSedeFiltro] = useState('');
    const [tipoFacturaFiltro, setTipoFacturaFiltro] = useState('');
    const [sedes, setSedes] = useState([]);

    // Modal Recibo de Caja
    const [showModalRecibo, setShowModalRecibo] = useState(false);
    const [facturaSeleccionada, setFacturaSeleccionada] = useState(null);
    const [valorRecibo, setValorRecibo] = useState('');
    const [medioPago, setMedioPago] = useState('10');
    const [fechaPago, setFechaPago] = useState(new Date().toISOString().split('T')[0]);
    const [observacionesRecibo, setObservacionesRecibo] = useState('');

    // Modal Nota Crédito Electrónica
    const [showModalNotaCredito, setShowModalNotaCredito] = useState(false);
    const [prefijos, setPrefijos] = useState([]);
    const [prefijoSeleccionado, setPrefijoSeleccionado] = useState('');
    const [numeroNotaCredito, setNumeroNotaCredito] = useState('');
    const [fechaNotaCredito, setFechaNotaCredito] = useState(new Date().toISOString().split('T')[0]);
    const [tipoNotaCredito, setTipoNotaCredito] = useState('total'); // 'total' | 'parcial'
    const [valorNotaCredito, setValorNotaCredito] = useState('');
    const [motivoNotaCredito, setMotivoNotaCredito] = useState('');

    // Modal Ver Recibos
    const [showModalRecibos, setShowModalRecibos] = useState(false);
    const [recibosFactura, setRecibosFactura] = useState([]);

    // Modal Éxito Recibo
    const [showModalExitoRecibo, setShowModalExitoRecibo] = useState(false);
    const [reciboGuardado, setReciboGuardado] = useState(null);

    // Modal Nota Crédito No Electrónica
    const [showModalNotaCreditoNE, setShowModalNotaCreditoNE] = useState(false);
    const [tipoNotaCreditoNE, setTipoNotaCreditoNE] = useState('total'); // 'total' | 'parcial'
    const [valorNotaCreditoNE, setValorNotaCreditoNE] = useState('');
    const [motivoNotaCreditoNE, setMotivoNotaCreditoNE] = useState('');
    const [fechaNotaCreditoNE, setFechaNotaCreditoNE] = useState(new Date().toISOString().split('T')[0]);
    const [consecutivoNCNE, setConsecutivoNCNE] = useState(null); // Datos del consecutivo
    const [loadingNCNE, setLoadingNCNE] = useState(false);

    // Dropdown Nueva Factura
    const [showDropdownFactura, setShowDropdownFactura] = useState(false);

    // Selección de facturas
    const [facturaSeleccionadaId, setFacturaSeleccionadaId] = useState(null);

    // Modal Completar Datos Factura
    const [showModalCompletarDatos, setShowModalCompletarDatos] = useState(false);
    const [facturaCompletarId, setFacturaCompletarId] = useState(null);

    // Paginación
    const [paginaActual, setPaginaActual] = useState(1);
    const registrosPorPagina = 12;

    // Modal Debug - Para mostrar respuestas de DIAN
    const [showModalDebug, setShowModalDebug] = useState(false);
    const [debugData, setDebugData] = useState(null);
    const [debugType, setDebugType] = useState(''); // 'success', 'error'

    // 🔒 Función helper para validar permisos
    const tienePermiso = (permiso) => {
        const userdata = JSON.parse(localStorage.getItem('userdata') || '{}');
        return userdata.up && userdata.up.includes(permiso);
    };

    useEffect(() => {
        // Validar permisos primero
        let userdata = [];
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        // Verificar si tiene permiso para ver listado de facturas
        const tienePermiso = userdata.up && userdata.up.includes('ver_listado_facturas');

        if (!tienePermiso) {
            setHasPermission(false);
            return; // Detener ejecución si no tiene permisos
        }

        setHasPermission(true);

        // Establecer fechas de la semana actual por defecto
        const hoy = new Date();
        const inicioSemana = new Date(hoy.setDate(hoy.getDate() - hoy.getDay()));
        const finSemana = new Date(hoy.setDate(hoy.getDate() - hoy.getDay() + 6));

        setFechaInicio(inicioSemana.toISOString().split('T')[0]);
        setFechaFin(finSemana.toISOString().split('T')[0]);

        // ✅ Ya NO necesitas config - el interceptor agrega el token automáticamente

        // Cargar cliente
        axios.get('/get-client?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        // Cargar usuarios del cliente
        axios.get('/users-by-client?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) {
                    setUsuarios(response.data);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        // Cargar pacientes
        axios.get('/pacientes?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) {
                    setPacientes(response.data);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        // Cargar sedes
        axios.get('/sedes?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) {
                    setSedes(response.data);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });
    }, []);

    useEffect(() => {
        if (loggedIn && fechaInicio && fechaFin) {
            cargarFacturas();
        }
    }, [loggedIn, fechaInicio, fechaFin, usuarioFiltro, estadoFiltro, sedeFiltro, tipoFacturaFiltro]);

    useEffect(() => {
        if (loggedIn && fechaInicio && fechaFin) {
            const timeoutId = setTimeout(() => {
                cargarFacturas();
            }, 500);
            return () => clearTimeout(timeoutId);
        }
    }, [busquedaPaciente]);

    const cargarFacturas = () => {
        let userdata = JSON.parse(localStorage.getItem('userdata'));
        // ✅ Ya NO necesitas config - el interceptor agrega el token automáticamente

        const params = new URLSearchParams({
            uid: userdata.user_id,
            fecha_inicio: fechaInicio,
            fecha_fin: fechaFin
        });

        if (usuarioFiltro) params.append('usuario_id', usuarioFiltro);
        if (busquedaPaciente) params.append('busqueda_paciente', busquedaPaciente);
        if (estadoFiltro !== '') params.append('estado', estadoFiltro);
        if (sedeFiltro) params.append('sede_id', sedeFiltro);
        if (tipoFacturaFiltro) params.append('tipo_factura', tipoFacturaFiltro);

        axios.get('/facturas?' + params.toString())
            .then(response => {
                if (response.status === 200) {
                    setFacturas(response.data);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });
    };

    const getNombrePaciente = (pacienteId) => {
        const paciente = pacientes.find(p => p.id === pacienteId);
        if (paciente) {
            return `${paciente.primer_nombre || ''} ${paciente.segundo_nombre || ''} ${paciente.primer_apellido || ''} ${paciente.segundo_apellido || ''}`.trim();
        }
        return 'N/A';
    };

    const getNombreUsuario = (usuarioId) => {
        const usuario = usuarios.find(u => u.id == usuarioId); // Usar == en lugar de === para comparación flexible
        return usuario ? usuario.name : 'N/A';
    };

    const getEstadoTexto = (estado) => {
        switch (estado) {
            case 0: return 'Generada';
            case 1: return 'Cobrada';
            case 2: return 'Por Cobrar';
            case 3: return 'Anulada';
            case 4: return 'Cobrada';
            case 5: return 'Por Cobrar';
            case 6: return 'Error DIAN';
            case 7: return 'Borrador RIPS';
            default: return 'Desconocido';
        }
    };

    const getEstadoColor = (estado) => {
        switch (estado) {
            case 0: return 'badge badge-outline-secondary';
            case 1: return 'badge badge-outline-success';
            case 2: return 'badge badge-outline-warning';
            case 3: return 'badge badge-outline-danger';
            case 4: return 'badge badge-outline-success';
            case 5: return 'badge badge-outline-warning';
            case 6: return 'badge badge-outline-danger';
            case 7: return 'badge badge-outline-info';
            default: return 'badge badge-outline-secondary';
        }
    };

    const abrirModalRecibo = (factura) => {
        setFacturaSeleccionada(factura);
        setValorRecibo(0);
        setMedioPago('10');
        setFechaPago(new Date().toISOString().split('T')[0]);
        setObservacionesRecibo('');
        setShowModalRecibo(true);
    };

    const guardarRecibo = async () => {
        const valorPendiente = facturaSeleccionada.valor_pendiente || facturaSeleccionada.valor_total;

        if (!valorRecibo || parseFloat(valorRecibo) <= 0) {
            alert('Ingrese un valor válido');
            return;
        }

        if (parseFloat(valorRecibo) > parseFloat(valorPendiente)) {
            alert(`El valor no puede ser mayor al saldo pendiente: $${Math.round(parseFloat(valorPendiente)).toLocaleString('es-CO')}`);
            return;
        }

        let userdata = JSON.parse(localStorage.getItem('userdata'));
        // ✅ Ya NO necesitas config - el interceptor agrega el token automáticamente

        const reciboData = {
            factura_id: facturaSeleccionada.id,
            valor_recibido: parseFloat(valorRecibo),
            medio_pago: medioPago,
            fecha_pago: fechaPago,
            observaciones: observacionesRecibo
        };

        try {
            const response = await axios.post('/recibo-caja', reciboData);
            if (response.status === 200 || response.status === 201) {
                setShowModalRecibo(false);
                setReciboGuardado(response.data);
                setShowModalExitoRecibo(true);
                cargarFacturas();
            }
        } catch (error) {
            alert('Error al registrar el recibo: ' + (error.response?.data?.message || error.message));
        }
    };

    const vistaPrevia = (facturaId) => {
        const url = `${window.location.origin}/smile/#/vista-previa-factura/${facturaId}`;
        window.open(url, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };

    const abrirModalNotaCredito = async (factura) => {
        setFacturaSeleccionada(factura);
        setPrefijoSeleccionado('');
        setNumeroNotaCredito('');
        setTipoNotaCredito('total');
        setValorNotaCredito('');
        setMotivoNotaCredito('');

        // Cargar prefijos filtrados por tipo NC y usuario de la factura
        let userdata = JSON.parse(localStorage.getItem('userdata'));
        //  Ya NO necesitas config - el interceptor agrega el token autom�ticamente

        try {
            const response = await axios.get('/parametros-fev?uid=' + userdata.user_id);
            if (response.status === 200) {
                const prefijosFiltrados = response.data.filter(param =>
                    param.tipo === 'Nota Credito' &&
                    param.users_id == factura.users_id &&
                    param.estado == 1
                );
                setPrefijos(prefijosFiltrados);
            }
        } catch (error) {
            console.log('Error cargando prefijos: ' + error);
        }

        setShowModalNotaCredito(true);
    };

    const handlePrefijoChange = (e) => {
        const prefijoId = e.target.value;
        setPrefijoSeleccionado(prefijoId);

        if (prefijoId) {
            const prefijo = prefijos.find(p => p.id == prefijoId);
            if (prefijo) {
                setNumeroNotaCredito(prefijo.numero_factura);
            }
        } else {
            setNumeroNotaCredito('');
        }
    };

    const anularFactura = async (facturaId) => {
        const factura = getFacturaSeleccionada();
        
        if (!factura) {
            alert('No se ha seleccionado ninguna factura');
            return;
        }

        // Mensaje diferente según el estado
        let mensaje = '¿Está seguro de anular esta factura?';
        if (factura.estado === 4) {
            mensaje = '¿Está seguro de anular esta factura de contado? Se generará una Nota Crédito automática para trazabilidad.';
        }

        if (!window.confirm(mensaje)) {
            return;
        }

        try {
            let response;
            
            if (factura.estado === 4) {
                // Estado 4: Usar endpoint especial que genera NC automática
                response = await axios.post('/anular-factura-contado', { 
                    factura_id: facturaId 
                });
            } else {
                // Otros estados: Anulación directa
                response = await axios.put(`/factura/${facturaId}/estado`, { estado: 3 });
            }
            
            if (response.status === 200 || response.data.success) {
                alert(response.data.message || 'Factura anulada exitosamente');
                cargarFacturas();
            }
        } catch (error) {
            alert('Error al anular la factura: ' + (error.response?.data?.message || error.message));
        }
    };

    const abrirCompletarDatos = (facturaId) => {
        setFacturaCompletarId(facturaId);
        setShowModalCompletarDatos(true);
    };

    const handleCompletarDatosSuccess = () => {
        setShowModalCompletarDatos(false);
        setFacturaCompletarId(null);
        cargarFacturas(); // Recargar el listado
    };

    const generarNotaCredito = async () => {
        if (!prefijoSeleccionado) {
            alert('Seleccione un prefijo');
            return;
        }

        if (!fechaNotaCredito) {
            alert('Seleccione una fecha');
            return;
        }

        if (!motivoNotaCredito.trim()) {
            alert('Ingrese el motivo de la nota crédito');
            return;
        }

        // Validar valor si es parcial
        if (tipoNotaCredito === 'parcial') {
            const valor = parseFloat(valorNotaCredito);
            const saldoPendiente = parseFloat(facturaSeleccionada?.valor_pendiente || facturaSeleccionada?.valor_total);
            
            if (!valorNotaCredito || valor <= 0) {
                alert('Ingrese un valor válido para la nota crédito');
                return;
            }
            
            if (valor > saldoPendiente) {
                alert(`El valor no puede ser mayor al saldo pendiente: $${Math.round(saldoPendiente).toLocaleString('es-CO')}`);
                return;
            }
        }

        const mensajeConfirmacion = tipoNotaCredito === 'total' 
            ? '¿Está seguro de generar una Nota Crédito TOTAL? Esta acción no se puede deshacer.'
            : `¿Está seguro de generar una Nota Crédito PARCIAL por $${Math.round(parseFloat(valorNotaCredito)).toLocaleString('es-CO')}? Esta acción no se puede deshacer.`;

        if (!window.confirm(mensajeConfirmacion)) {
            return;
        }

        let userdata = JSON.parse(localStorage.getItem('userdata'));
        // ✅ Ya NO necesitas config - el interceptor agrega el token automáticamente

        const notaCreditoData = {
            factura_id: facturaSeleccionada.id,
            parametrosfev_id: prefijoSeleccionado,
            motivo: motivoNotaCredito,
            fecha_emision: fechaNotaCredito,
            tipo: tipoNotaCredito,
            valor: tipoNotaCredito === 'parcial' ? parseFloat(valorNotaCredito) : null
        };

        try {
            const response = await axios.post('/nota-credito/enviar-dian-directo', notaCreditoData);

            setShowModalNotaCredito(false);

            if (response.data.success) {
                setDebugType('success');
                setDebugData({
                    message: response.data.message,
                    cufe: response.data.uuid,
                    numero_nc: response.data.numero_nc,
                    recibos_anulados: response.data.recibos_anulados,
                    facturaId: facturaSeleccionada.id
                });
                setShowModalDebug(true);
            } else {
                setDebugType('error');
                setDebugData({
                    message: response.data.message,
                    response: response.data.response,
                    json_enviado: response.data.json_enviado,
                    status_code: response.data.status_code,
                    facturaId: facturaSeleccionada.id
                });
                setShowModalDebug(true);
            }

            cargarFacturas();
            setPrefijoSeleccionado('');
            setNumeroNotaCredito('');
            setFechaNotaCredito(new Date().toISOString().split('T')[0]);
            setTipoNotaCredito('total');
            setValorNotaCredito('');
            setMotivoNotaCredito('');

        } catch (error) {
            console.error('Error al generar nota crédito:', error);
            setShowModalNotaCredito(false);

            setDebugType('error');
            setDebugData({
                message: error.response?.data?.message || error.message,
                error: error.response?.data?.error,
                response: error.response?.data?.response,
                json_enviado: error.response?.data?.json_enviado,
                fullError: error.response?.data,
                facturaId: facturaSeleccionada.id
            });
            setShowModalDebug(true);
        }
    };

    const verRecibos = async (factura) => {
        setFacturaSeleccionada(factura);

        let userdata = JSON.parse(localStorage.getItem('userdata'));
        //  Ya NO necesitas config - el interceptor agrega el token autom�ticamente

        try {
            const response = await axios.get(`/recibos-caja/${factura.id}?uid=${userdata.user_id}`);
            if (response.status === 200) {
                setRecibosFactura(response.data);
                setShowModalRecibos(true);
            }
        } catch (error) {
            alert('Error al cargar los recibos: ' + (error.response?.data?.message || error.message));
        }
    };

    const getMedioPagoTexto = (codigo) => {
        const mediosPago = {
            '10': 'Efectivo',
            '42': 'Consignación bancaria',
            '1': 'Instrumento no definido',
            '20': 'Cheque',
            '30': 'Transferencia Crédito',
            '31': 'Transferencia Débito',
            '45': 'Transferencia Crédito Bancario',
            '47': 'Transferencia Débito Bancaria',
            '48': 'Tarjeta Crédito',
            '49': 'Tarjeta Débito',
            'ZZZ': 'Acuerdo mutuo'
        };
        return mediosPago[codigo] || codigo;
    };

    const formatearValor = (valor) => {
        return '$' + Math.round(parseFloat(valor)).toLocaleString('es-CO');
    };

    const anularRecibo = async (reciboId) => {
        if (!window.confirm('¿Está seguro de anular este recibo?')) {
            return;
        }

        let userdata = JSON.parse(localStorage.getItem('userdata'));
        // ✅ Ya NO necesitas config - el interceptor agrega el token automáticamente

        // Mantener el estado actual según el tipo de factura
        // Estado 2: Por Cobrar (Electrónica) - mantener en 2
        // Estado 5: Por Cobrar (No Electrónica) - mantener en 5
        const estadoDestino = facturaSeleccionada.estado === 5 ? 5 : 2;

        try {
            const response = await axios.put(`/recibo-caja/${reciboId}/anular?uid=${userdata.user_id}`,
                { estado_factura_destino: estadoDestino }
            );
            if (response.status === 200) {
                alert('Recibo anulado exitosamente');
                verRecibos(facturaSeleccionada);
                cargarFacturas();
            }
        } catch (error) {
            alert('Error al anular el recibo: ' + (error.response?.data?.message || error.message));
        }
    };

    const formatearFecha = (fecha) => {
        if (!fecha) return '';
        const date = new Date(fecha);
        const dia = String(date.getDate()).padStart(2, '0');
        const mes = String(date.getMonth() + 1).padStart(2, '0');
        const anio = String(date.getFullYear()).slice(-2);
        return `${dia}/${mes}/${anio}`;
    };

    const construirDireccionCompleta = (paciente) => {
        if (!paciente) return '';
        const partes = [];
        if (paciente.direccion) partes.push(paciente.direccion);
        if (paciente.zona) partes.push(paciente.zona);
        if (paciente.nombre_ciudad_residencia) partes.push(paciente.nombre_ciudad_residencia);
        if (paciente.nombre_departamento_residencia) partes.push(paciente.nombre_departamento_residencia);
        if (paciente.nombre_pais_residencia) partes.push(paciente.nombre_pais_residencia);
        return partes.join(', ') || paciente.direccion || '';
    };

    const obtenerNit = () => {
        if (client?.numero_documento) {
            return client.digito_verificacion
                ? `${client.numero_documento}-${client.digito_verificacion}`
                : client.numero_documento;
        }
        return '';
    };

    const vistaPreviaRecibo = async (recibo) => {
        let paciente = pacientes.find(p => p.id === facturaSeleccionada?.paciente_id);

        // Siempre cargar los datos completos del paciente para asegurar que tenemos todos los campos
        let userdata = JSON.parse(localStorage.getItem('userdata'));
        //  Ya NO necesitas config - el interceptor agrega el token autom�ticamente
        try {
            const response = await axios.get(`/paciente?uid=${userdata.user_id}&id=${facturaSeleccionada?.paciente_id}`);
            if (response.data && response.data.length > 0) {
                paciente = response.data[0];
                console.log('Paciente cargado:', paciente);
                console.log('Teléfono:', paciente.telefono);
                console.log('Celular:', paciente.celular);
            }
        } catch (error) {
            console.log('Error cargando paciente completo:', error);
        }

        const nombrePaciente = paciente ? `${paciente.primer_nombre || ''} ${paciente.segundo_nombre || ''} ${paciente.primer_apellido || ''} ${paciente.segundo_apellido || ''}`.trim() : getNombrePaciente(facturaSeleccionada?.paciente_id);

        // 🆕 Obtener nombre del facturador (usuario que creó la factura)
        const nombreFacturador = facturaSeleccionada?.users_id ? getNombreUsuario(facturaSeleccionada.users_id) : 'N/A';

        // 🆕 BANNER: RECIBO DE CAJA
        const bannerHTML = `
            <div style="margin-bottom: 10px;">
                <div style="background-color: #e9ecef; padding: 8px 12px; font-weight: bold; font-size: 13px; border-radius: 3px; text-align: center;">
                    RECIBO DE CAJA - FACTURA N° ${facturaSeleccionada?.numero_factura || ''}
                </div>
            </div>
        `;

        // 🆕 Datos del recibo en tabla
        const datosReciboHTML = `
            <table style="width: 100%; border-collapse: collapse; margin-bottom: 15px; font-size: 11px;">
                <tbody>
                    <tr>
                        <td style="background-color: #e9ecef; font-weight: bold; width: 15%; vertical-align: middle; padding: 6px; border: 1px solid #dee2e6;">RECIBO #</td>
                        <td style="background-color: #ffffff; width: 18%; padding: 6px; border: 1px solid #dee2e6;">${recibo.numero_recibo}</td>
                        <td style="background-color: #e9ecef; font-weight: bold; width: 15%; vertical-align: middle; padding: 6px; border: 1px solid #dee2e6;">FECHA PAGO</td>
                        <td style="background-color: #ffffff; width: 18%; padding: 6px; border: 1px solid #dee2e6;">${formatearFecha(recibo.fecha_pago)}</td>
                        <td style="background-color: #e9ecef; font-weight: bold; width: 15%; vertical-align: middle; padding: 6px; border: 1px solid #dee2e6;">FORMA DE PAGO</td>
                        <td style="background-color: #ffffff; width: 19%; padding: 6px; border: 1px solid #dee2e6;">${getMedioPagoTexto(recibo.forma_pago)}</td>
                    </tr>
                    <tr>
                        <td style="background-color: #e9ecef; font-weight: bold; vertical-align: middle; padding: 6px; border: 1px solid #dee2e6;">FACTURADOR</td>
                        <td colspan="5" style="background-color: #ffffff; padding: 6px; border: 1px solid #dee2e6;">${nombreFacturador}</td>
                    </tr>
                </tbody>
            </table>
        `;

        const contenidoRecibo = `
            <div style="container-fluid p-4">
                <div class="no-print" style="margin-bottom: 20px;">
                    <button onclick="window.print()" style="padding: 10px 20px; background: #007bff; color: white; border: none; border-radius: 4px; cursor: pointer; margin-right: 10px;">Imprimir</button>
                    <button onclick="window.close()" style="padding: 10px 20px; background: #6c757d; color: white; border: none; border-radius: 4px; cursor: pointer;">Cerrar</button>
                </div>

                <div style="padding: 15px; margin-bottom: 20px;">
                    ${bannerHTML}
                    
                    ${datosReciboHTML}

                    <table style="width: 100%; border-collapse: collapse; background-color: #f8f9fa; font-size: 12px; margin-bottom: 20px;">
                        <tbody>
                            <tr>
                                <td style="background-color: #e9ecef; font-weight: bold; width: 15%; vertical-align: middle; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">RAZÓN SOCIAL</td>
                                <td style="background-color: #ffffff; width: 35%; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">${nombrePaciente}</td>
                                <td style="background-color: #e9ecef; font-weight: bold; width: 15%; vertical-align: middle; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">NIT</td>
                                <td style="background-color: #ffffff; width: 35%; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">${obtenerNit()}</td>
                            </tr>
                            <tr>
                                <td style="background-color: #e9ecef; font-weight: bold; vertical-align: middle; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">TELÉFONO</td>
                                <td style="background-color: #ffffff; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">${paciente ? (paciente.telefono || '') : ''}</td>
                                <td style="background-color: #e9ecef; font-weight: bold; vertical-align: middle; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">CELULAR</td>
                                <td style="background-color: #ffffff; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">${paciente ? (paciente.celular || '') : ''}</td>
                            </tr>
                            <tr>
                                <td style="background-color: #e9ecef; font-weight: bold; vertical-align: middle; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">EMAIL</td>
                                <td style="background-color: #ffffff; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">${paciente ? (paciente.email || '') : ''}</td>
                                <td style="background-color: #e9ecef; font-weight: bold; vertical-align: middle; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">DIRECCIÓN</td>
                                <td style="background-color: #ffffff; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">${construirDireccionCompleta(paciente)}</td>
                            </tr>
                        </tbody>
                    </table>

                    <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;">
                        <thead>
                            <tr style="background-color: #e9ecef;">
                                <th style="border: 1px solid #dee2e6; padding: 8px; text-align: left; font-size: 12px;">Concepto</th>
                                <th style="border: 1px solid #dee2e6; padding: 8px; text-align: right; font-size: 12px;">Valor</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style="border: 1px solid #dee2e6; padding: 8px; background-color: #ffffff;">Abono a Factura N° ${facturaSeleccionada?.numero_factura || ''}</td>
                                <td style="border: 1px solid #dee2e6; padding: 8px; text-align: right; background-color: #ffffff; font-weight: bold;">$${Math.round(parseFloat(recibo.valor_pago)).toLocaleString('es-CO')}</td>
                            </tr>
                        </tbody>
                    </table>

                    <div style="display: flex; justify-content: flex-end; padding-right: 15px;">
                        <table style="width: auto; border-collapse: collapse;">
                            <tbody>
                                <tr>
                                    <td style="text-align: right; padding: 8px 16px 8px 8px; border: none; font-weight: bold; white-space: nowrap;">Total:</td>
                                    <td style="text-align: right; padding: 8px; border: none; min-width: 130px; font-family: monospace;">$${Math.round(parseFloat(recibo.valor_pago)).toLocaleString('es-CO')}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    ${recibo.observaciones ? `
                    <div style="margin-top: 20px;">
                        <h6 style="font-size: 14px; font-weight: bold;">Observaciones:</h6>
                        <p style="font-size: 12px;">${recibo.observaciones}</p>
                    </div>
                    ` : ''}

                    <div style="margin-top: 40px; text-align: center; border-top: 1px solid #ddd; padding-top: 20px;">
                        <p style="color: #666; margin-bottom: 30px; font-size: 12px;">Recibí conforme el valor arriba mencionado</p>
                        <div style="margin-top: 50px;">
                            <div style="border-top: 1px solid #333; width: 200px; margin: 0 auto;"></div>
                            <p style="margin-top: 5px; color: #666; font-size: 12px;">Firma del Paciente</p>
                        </div>
                    </div>
                </div>

                <style>
                    @media print {
                        .no-print {
                            display: none !important;
                        }
                        body {
                            margin: 0;
                            padding: 0;
                        }
                    }
                </style>
            </div>
        `;

        const ventana = window.open('', '_blank', 'width=800,height=700,scrollbars=yes,resizable=yes');
        ventana.document.write(`
            <!DOCTYPE html>
            <html>
            <head>
                <title>Recibo de Caja N° ${recibo.numero_recibo}</title>
                <style>
                    body { font-family: Arial, sans-serif; margin: 20px; background: #fff; }
                    @media print { 
                        body { margin: 0; padding: 0; }
                        .no-print { display: none !important; }
                    }
                </style>
            </head>
            <body>
                ${contenidoRecibo}
            </body>
            </html>
        `);
        ventana.document.close();
    };

    const vistaPreviaRecibos = async () => {
        let paciente = pacientes.find(p => p.id === facturaSeleccionada?.paciente_id);

        // Siempre cargar los datos completos del paciente para asegurar que tenemos todos los campos
        let userdata = JSON.parse(localStorage.getItem('userdata'));
        //  Ya NO necesitas config - el interceptor agrega el token autom�ticamente
        try {
            const response = await axios.get(`/paciente?uid=${userdata.user_id}&id=${facturaSeleccionada?.paciente_id}`);
            if (response.data && response.data.length > 0) {
                paciente = response.data[0];
                console.log('Paciente cargado (recibos):', paciente);
                console.log('Teléfono:', paciente.telefono);
                console.log('Celular:', paciente.celular);
            }
        } catch (error) {
            console.log('Error cargando paciente completo:', error);
        }

        const nombrePaciente = paciente ? `${paciente.primer_nombre || ''} ${paciente.segundo_nombre || ''} ${paciente.primer_apellido || ''} ${paciente.segundo_apellido || ''}`.trim() : getNombrePaciente(facturaSeleccionada?.paciente_id);
        const totalRecibosActivos = recibosFactura.filter(r => r.estado !== 0).reduce((sum, r) => sum + parseFloat(r.valor_pago), 0);

        // 🆕 Obtener nombre del facturador (usuario que creó la factura)
        const nombreFacturador = facturaSeleccionada?.users_id ? getNombreUsuario(facturaSeleccionada.users_id) : 'N/A';

        // 🆕 BANNER: RECIBOS DE CAJA
        const bannerHTML = `
            <div style="margin-bottom: 10px;">
                <div style="background-color: #e9ecef; padding: 8px 12px; font-weight: bold; font-size: 13px; border-radius: 3px; text-align: center;">
                    RECIBOS DE CAJA - FACTURA N° ${facturaSeleccionada?.numero_factura || ''}
                </div>
            </div>
        `;

        // 🆕 Datos del reporte en tabla
        const datosReporteHTML = `
            <table style="width: 100%; border-collapse: collapse; margin-bottom: 15px; font-size: 11px;">
                <tbody>
                    <tr>
                        <td style="background-color: #e9ecef; font-weight: bold; width: 15%; vertical-align: middle; padding: 6px; border: 1px solid #dee2e6;">FECHA REPORTE</td>
                        <td style="background-color: #ffffff; width: 35%; padding: 6px; border: 1px solid #dee2e6;">${formatearFecha(new Date().toISOString())}</td>
                        <td style="background-color: #e9ecef; font-weight: bold; width: 15%; vertical-align: middle; padding: 6px; border: 1px solid #dee2e6;">FACTURADOR</td>
                        <td style="background-color: #ffffff; width: 35%; padding: 6px; border: 1px solid #dee2e6;">${nombreFacturador}</td>
                    </tr>
                </tbody>
            </table>
        `;

        const contenidoRecibos = `
            <div style="container-fluid p-4">
                <div class="no-print" style="margin-bottom: 20px;">
                    <button onclick="window.print()" style="padding: 10px 20px; background: #007bff; color: white; border: none; border-radius: 4px; cursor: pointer; margin-right: 10px;">Imprimir</button>
                    <button onclick="window.close()" style="padding: 10px 20px; background: #6c757d; color: white; border: none; border-radius: 4px; cursor: pointer;">Cerrar</button>
                </div>

                <div style="padding: 15px; margin-bottom: 20px;">
                    ${bannerHTML}
                    
                    ${datosReporteHTML}

                    <table style="width: 100%; border-collapse: collapse; background-color: #f8f9fa; font-size: 12px; margin-bottom: 20px;">
                        <tbody>
                            <tr>
                                <td style="background-color: #e9ecef; font-weight: bold; width: 15%; vertical-align: middle; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">RAZÓN SOCIAL</td>
                                <td style="background-color: #ffffff; width: 35%; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">${nombrePaciente}</td>
                                <td style="background-color: #e9ecef; font-weight: bold; width: 15%; vertical-align: middle; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">NIT</td>
                                <td style="background-color: #ffffff; width: 35%; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">${obtenerNit()}</td>
                            </tr>
                            <tr>
                                <td style="background-color: #e9ecef; font-weight: bold; vertical-align: middle; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">TELÉFONO</td>
                                <td style="background-color: #ffffff; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">${paciente ? (paciente.telefono || '') : ''}</td>
                                <td style="background-color: #e9ecef; font-weight: bold; vertical-align: middle; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">CELULAR</td>
                                <td style="background-color: #ffffff; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">${paciente ? (paciente.celular || '') : ''}</td>
                            </tr>
                            <tr>
                                <td style="background-color: #e9ecef; font-weight: bold; vertical-align: middle; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">EMAIL</td>
                                <td style="background-color: #ffffff; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">${paciente ? (paciente.email || '') : ''}</td>
                                <td style="background-color: #e9ecef; font-weight: bold; vertical-align: middle; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">DIRECCIÓN</td>
                                <td style="background-color: #ffffff; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">${construirDireccionCompleta(paciente)}</td>
                            </tr>
                        </tbody>
                    </table>

                    <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;">
                        <thead>
                            <tr style="background-color: #e9ecef;">
                                <th style="border: 1px solid #dee2e6; padding: 8px; text-align: left; font-size: 12px;">N° Recibo</th>
                                <th style="border: 1px solid #dee2e6; padding: 8px; text-align: left; font-size: 12px;">Fecha Pago</th>
                                <th style="border: 1px solid #dee2e6; padding: 8px; text-align: right; font-size: 12px;">Valor</th>
                                <th style="border: 1px solid #dee2e6; padding: 8px; text-align: left; font-size: 12px;">Medio Pago</th>
                                <th style="border: 1px solid #dee2e6; padding: 8px; text-align: center; font-size: 12px;">Estado</th>
                                <th style="border: 1px solid #dee2e6; padding: 8px; text-align: left; font-size: 12px;">Observaciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${recibosFactura.map((recibo, index) => `
                                <tr style="background-color: ${index % 2 === 0 ? '#f8f9fa' : '#ffffff'};">
                                    <td style="border: 1px solid #dee2e6; padding: 8px; font-size: 12px;">${recibo.numero_recibo}</td>
                                    <td style="border: 1px solid #dee2e6; padding: 8px; font-size: 12px;">${formatearFecha(recibo.fecha_pago)}</td>
                                    <td style="border: 1px solid #dee2e6; padding: 8px; text-align: right; font-size: 12px; font-weight: bold;">$${Math.round(parseFloat(recibo.valor_pago)).toLocaleString('es-CO')}</td>
                                    <td style="border: 1px solid #dee2e6; padding: 8px; font-size: 12px;">${getMedioPagoTexto(recibo.forma_pago)}</td>
                                    <td style="border: 1px solid #dee2e6; padding: 8px; text-align: center; font-size: 12px;">
                                        <span style="padding: 4px 8px; border-radius: 3px; font-size: 11px; font-weight: bold; color: white; background: ${recibo.estado === 0 ? '#dc3545' : '#28a745'};">
                                            ${recibo.estado === 0 ? 'Anulado' : 'Activo'}
                                        </span>
                                    </td>
                                    <td style="border: 1px solid #dee2e6; padding: 8px; font-size: 12px;">${recibo.observaciones || '-'}</td>
                                </tr>
                            `).join('')}
                        </tbody>
                    </table>

                    <div style="display: flex; justify-content: flex-end; padding-right: 15px;">
                        <table style="width: auto; border-collapse: collapse;">
                            <tbody>
                                <tr>
                                    <td style="text-align: right; padding: 8px 16px 8px 8px; border: none; font-weight: bold; white-space: nowrap;">Total Recibos Activos:</td>
                                    <td style="text-align: right; padding: 8px; border: none; min-width: 130px; font-family: monospace; font-weight: bold;">$${Math.round(totalRecibosActivos).toLocaleString('es-CO')}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <style>
                    @media print {
                        .no-print {
                            display: none !important;
                        }
                        body {
                            margin: 0;
                            padding: 0;
                        }
                    }
                </style>
            </div>
        `;

        const ventana = window.open('', '_blank', 'width=900,height=700,scrollbars=yes,resizable=yes');
        ventana.document.write(`
            <!DOCTYPE html>
            <html>
            <head>
                <title>Recibos de Caja - Factura ${facturaSeleccionada?.numero_factura}</title>
                <style>
                    body { font-family: Arial, sans-serif; margin: 20px; background: #fff; }
                    @media print { 
                        body { margin: 0; padding: 0; }
                        .no-print { display: none !important; }
                    }
                </style>
            </head>
            <body>
                ${contenidoRecibos}
            </body>
            </html>
        `);
        ventana.document.close();
    };

    const enviarWhatsAppFactura = async (factura) => {
        let userdata = JSON.parse(localStorage.getItem('userdata'));
        let celularPaciente = '';
        let nombrePaciente = '';

        try {
            // Get patient info
            const response = await axios.get(`/paciente?uid=${userdata.user_id}&id=${factura.paciente_id}`);
            if (response.data && response.data.length > 0) {
                const paciente = response.data[0];
                celularPaciente = paciente.celular || paciente.telefono;
                nombrePaciente = `${paciente.primer_nombre} ${paciente.primer_apellido}`;
            }
        } catch (error) {
            console.log('Error getting patient info:', error);
            // Fallback if we can't get fresh info (using data from list if available, though list might not have phone)
        }

        if (!celularPaciente) {
            alert('El paciente no tiene número de celular registrado.');
            return;
        }

        const msg = `Hola ${nombrePaciente}, adjunto la factura N° ${factura.numero_factura} por valor de $${Math.round(factura.valor_total).toLocaleString('es-CO')}.`;
        const url = `https://wa.me/57${celularPaciente}?text=${encodeURIComponent(msg)}`;
        window.open(url, '_blank');
    };

    const getFacturaSeleccionada = () => {
        return facturas.find(f => f.id === facturaSeleccionadaId);
    };

    const handleSeleccionFactura = (facturaId) => {
        setFacturaSeleccionadaId(facturaSeleccionadaId === facturaId ? null : facturaId);
    };

    // Calcular facturas paginadas
    const indiceUltimoRegistro = paginaActual * registrosPorPagina;
    const indicePrimerRegistro = indiceUltimoRegistro - registrosPorPagina;
    const facturasPaginadas = facturas.slice(indicePrimerRegistro, indiceUltimoRegistro);
    const totalPaginas = Math.ceil(facturas.length / registrosPorPagina);

    const cambiarPagina = (numeroPagina) => {
        setPaginaActual(numeroPagina);
        setFacturaSeleccionadaId(null); // Deseleccionar al cambiar de página
    };

    // Resetear a página 1 cuando cambien los filtros
    useEffect(() => {
        setPaginaActual(1);
    }, [fechaInicio, fechaFin, usuarioFiltro, estadoFiltro, sedeFiltro, tipoFacturaFiltro, busquedaPaciente]);

    const reenviarFacturaDian = async (facturaId) => {
        if (!window.confirm('¿Está seguro de reintentar el envío de esta factura a la DIAN?')) {
            return;
        }

        let userdata = JSON.parse(localStorage.getItem('userdata'));
        // ✅ Ya NO necesitas config - el interceptor agrega el token automáticamente

        try {
            const response = await axios.post(`/factura/${facturaId}/enviar-dian`, {});

            console.log('Respuesta completa de enviar-dian:', response.data);

            if (response.data.success) {
                setDebugType('success');
                setDebugData({
                    message: 'Factura enviada exitosamente a la DIAN',
                    cufe: response.data.uuid,
                    estado: response.data.estado,
                    facturaId: facturaId
                });
                setShowModalDebug(true);
                cargarFacturas();
            } else {
                // Cuando success = false, mostrar el error con toda la información
                console.log('Error de DIAN - response.data:', response.data);
                setDebugType('error');
                setDebugData({
                    message: response.data.message || 'Error al enviar a la DIAN',
                    response: response.data.response || response.data.error,
                    json_enviado: response.data.json_enviado,
                    status_code: response.data.status_code,
                    fullError: response.data,
                    facturaId: facturaId
                });
                setShowModalDebug(true);
            }
        } catch (error) {
            console.error('Error al enviar a DIAN (catch):', error);
            console.log('error.response?.data:', error.response?.data);
            console.log('error.response?.data completo:', JSON.stringify(error.response?.data, null, 2));

            // Construir debugData con toda la información disponible
            const errorData = {
                message: error.response?.data?.message || error.message || 'Error al enviar a la DIAN',
                error: error.response?.data?.error,
                response: error.response?.data?.response,
                json_enviado: error.response?.data?.json_enviado,
                status_code: error.response?.status || error.response?.data?.status_code,
                fullError: error.response?.data || error,
                facturaId: facturaId
            };

            console.log('debugData que se va a mostrar:', errorData);

            setDebugType('error');
            setDebugData(errorData);
            setShowModalDebug(true);
        }
    };

    const verJsonPreview = async (facturaId) => {
        let userdata = JSON.parse(localStorage.getItem('userdata'));
        //  Ya NO necesitas config - el interceptor agrega el token autom�ticamente

        try {
            const response = await axios.get(`/factura/${facturaId}/json-dian?uid=${userdata.user_id}`);

            setDebugType('json');
            setDebugData({
                message: 'JSON que se enviará a la DIAN',
                subtitle: `Factura ID: ${facturaId}`,
                json: response.data
            });
            setShowModalDebug(true);
        } catch (error) {
            console.error('Error al generar JSON:', error);
            alert('Error al generar JSON: ' + (error.response?.data?.message || error.message));
        }
    };

    // ==========================================
    // Lógica para Nota Crédito No Electrónica
    // ==========================================

    const abrirModalNotaCreditoNoElectronica = async (factura) => {
        let userdata = JSON.parse(localStorage.getItem('userdata'));

        setFacturaSeleccionada(factura);
        setLoadingNCNE(true);

        try {
            const response = await axios.get('/consecutivo-nc-no-electronica?uid=' + userdata.user_id);
            if (response.data) {
                setConsecutivoNCNE(response.data);

                // Inicializar formulario
                setTipoNotaCreditoNE('total');
                // Valor por defecto: el pendiente (o total si no hay pagos)
                const saldo = parseFloat(factura.valor_pendiente || factura.valor_total);
                setValorNotaCreditoNE(saldo);
                setMotivoNotaCreditoNE('');
                setFechaNotaCreditoNE(new Date().toISOString().split('T')[0]);

                setShowModalNotaCreditoNE(true);
            } else {
                alert('No se ha configurado un consecutivo para Notas Crédito No Electrónicas. Vaya a Configuración > Administrador Contable.');
            }
        } catch (error) {
            console.error(error);
            alert('Error al obtener consecutivo de Notas Crédito.');
        } finally {
            setLoadingNCNE(false);
        }
    };

    const generarNotaCreditoNE = async (e) => {
        e.preventDefault();

        if (!facturaSeleccionada || !consecutivoNCNE) return;

        let userdata = JSON.parse(localStorage.getItem('userdata'));
        const saldoPendiente = parseFloat(facturaSeleccionada.valor_pendiente || facturaSeleccionada.valor_total);
        const valorAplicar = parseFloat(valorNotaCreditoNE);

        // Validaciones
        if (valorAplicar <= 0) {
            alert("El valor de la nota crédito debe ser mayor a 0.");
            return;
        }

        if (valorAplicar > saldoPendiente + 100) { // Tolerancia pequeña por redondeo
            alert(`El valor de la nota crédito ($${valorAplicar.toLocaleString()}) no puede superar el saldo pendiente de la factura ($${saldoPendiente.toLocaleString()}).`);
            return;
        }

        if (!motivoNotaCreditoNE.trim()) {
            alert("Debe ingresar un motivo para la nota crédito.");
            return;
        }

        if (!window.confirm(`¿Está seguro de generar una Nota Crédito por valor de $${valorAplicar.toLocaleString()}? Esta acción afectará el saldo y el consecutivo.`)) {
            return;
        }

        const data = {
            factura_id: facturaSeleccionada.id,
            valor: valorAplicar,
            motivo: motivoNotaCreditoNE,
            fecha: fechaNotaCreditoNE,
            consecutivo_id: consecutivoNCNE.id,
            tipo_nota: tipoNotaCreditoNE // 'total' o 'parcial'
        };

        setLoadingNCNE(true);

        try {
            const response = await axios.post('/nota-credito-no-electronica?uid=' + userdata.user_id, data);

            if (response.data.success) {
                alert('Nota Crédito generada exitosamente: ' + response.data.numero_nota);
                setShowModalNotaCreditoNE(false);
                cargarFacturas(); // Recargar lista
            } else {
                alert('Error al generar: ' + JSON.stringify(response.data));
            }

        } catch (error) {
            console.error(error);
            alert('Error al generar la Nota Crédito: ' + (error.response?.data?.message || error.message));
        } finally {
            setLoadingNCNE(false);
        }
    };

    if (loggedIn) {
        return (
            <div className="hold-transition">
                <style>{`
                    .table-info {
                        background-color: #f6fcfd !important;
                        border-left: 4px solid #17a2b8;
                    }
                    .table tbody tr:hover {
                        background-color: #f6fcfd;
                        transform: scale(1.001);
                        transition: all 0.2s ease;
                    }
                    .table tbody tr.table-info:hover {
                        background-color: #e6f7f9 !important;
                        box-shadow: 0 2px 4px rgba(23, 162, 184, 0.15);
                    }
                    .badge-lg {
                        font-size: 0.85em;
                        padding: 0.5em 0.75em;
                    }
                    .badge-outline-secondary {
                        color: #6c757d;
                        border: 1px solid #6c757d;
                        background-color: transparent;
                    }
                    .badge-outline-success {
                        color: #28a745;
                        border: 1px solid #28a745;
                        background-color: transparent;
                    }
                    .badge-outline-warning {
                        color: #ffc107;
                        border: 1px solid #ffc107;
                        background-color: transparent;
                    }
                    .badge-outline-danger {
                        color: #dc3545;
                        border: 1px solid #dc3545;
                        background-color: transparent;
                    }
                    .btn-toolbar {
                        gap: 0.5rem;
                    }
                    .card-header.bg-gradient-light {
                        background: linear-gradient(135deg, #f6fcfd 0%, #e6f7f9 100%);
                        border-bottom: 2px solid #17a2b8;
                    }
                    .shadow-sm {
                        box-shadow: 0 0.125rem 0.25rem rgba(23, 162, 184, 0.1) !important;
                    }
                    .table th {
                        background-color: #282828;
                        color: #f6fcfd;
                        border-top: none;
                        font-weight: 600;
                        font-size: 0.9rem;
                    }
                    .table td {
                        vertical-align: middle;
                        font-size: 0.9rem;
                    }
                    .btn-group .btn {
                        border-radius: 0.25rem;
                        margin-right: 1px;
                    }
                    .btn-group .btn:first-child {
                        border-top-right-radius: 0;
                        border-bottom-right-radius: 0;
                    }
                    .btn-group .btn:last-child {
                        border-top-left-radius: 0;
                        border-bottom-left-radius: 0;
                        margin-right: 0;
                    }
                    .btn-group .btn:not(:first-child):not(:last-child) {
                        border-radius: 0;
                    }
                    .card-primary.card-outline {
                        border-top: 3px solid #17a2b8;
                    }
                    .card-info.card-outline {
                        border-top: 3px solid #17a2b8;
                    }
                    .pagination .page-item.active .page-link {
                        background-color: #282828;
                        border-color: #282828;
                        color: #f6fcfd;
                    }
                    .pagination .page-link {
                        color: #282828;
                        border-color: #dee2e6;
                    }
                    .pagination .page-link:hover {
                        background-color: #f6fcfd;
                        border-color: #17a2b8;
                        color: #282828;
                    }
                    .pagination .page-item.disabled .page-link {
                        color: #6c757d;
                        background-color: #fff;
                        border-color: #dee2e6;
                    }
                `}</style>
                <Header client={client} />
                <Aside client={client} activelink="billing" />

                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb float-sm-left">
                                        <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                        <li className="breadcrumb-item"><Link to="/menu-facturacion">Contabilidad</Link></li>
                                        <li className="breadcrumb-item active">Listado de Facturas</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">Listado de Facturas</h1>
                                </div>
                                <div className="col-sm-4">
                                    <div className="dropdown float-right">
                                        <button
                                            className="btn btn-primary dropdown-toggle"
                                            type="button"
                                            onClick={() => setShowDropdownFactura(!showDropdownFactura)}
                                        >
                                            <i className="fas fa-plus"></i> Nueva Factura
                                        </button>
                                        {showDropdownFactura && (
                                            <div className="dropdown-menu show" style={{ position: 'absolute', right: 0 }}>
                                                <Link
                                                    to="/crear-factura"
                                                    className="dropdown-item"
                                                    onClick={() => setShowDropdownFactura(false)}
                                                >
                                                    <i className="fas fa-plus"></i> Electrónica
                                                </Link>
                                                <Link
                                                    to="/crear-factura-no-electronica"
                                                    className="dropdown-item"
                                                    onClick={() => setShowDropdownFactura(false)}
                                                >
                                                    <i className="fas fa-plus"></i> No Electrónica
                                                </Link>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">

                            {/* Filtros */}
                            <div className="card card-info card-outline">
                                <div className="card-header">
                                    <h5><b>Filtros</b></h5>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label>Fecha Inicio</label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    value={fechaInicio}
                                                    onChange={(e) => setFechaInicio(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label>Fecha Fin</label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    value={fechaFin}
                                                    onChange={(e) => setFechaFin(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label>Profesional</label>
                                                <select
                                                    className="form-control"
                                                    value={usuarioFiltro}
                                                    onChange={(e) => setUsuarioFiltro(e.target.value)}
                                                >
                                                    <option value="">Todos</option>
                                                    {usuarios.map(usuario => (
                                                        <option key={usuario.id} value={usuario.id}>{usuario.name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label>Estado</label>
                                                <select
                                                    className="form-control"
                                                    value={estadoFiltro}
                                                    onChange={(e) => setEstadoFiltro(e.target.value)}
                                                >
                                                    <option value="">Todos</option>
                                                    <option value="0">Generada</option>
                                                    <option value="1">Cancelada</option>
                                                    <option value="2">Por Cobrar</option>
                                                    <option value="3">Anulada</option>
                                                    <option value="4">No Electrónica Contado</option>
                                                    <option value="5">No Electrónica Crédito</option>
                                                    <option value="6">Error DIAN</option>
                                                    <option value="7">Borrador RIPS</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label>Sede</label>
                                                <select
                                                    className="form-control"
                                                    value={sedeFiltro}
                                                    onChange={(e) => setSedeFiltro(e.target.value)}
                                                >
                                                    <option value="">Todas</option>
                                                    {sedes.map(sede => (
                                                        <option key={sede.id} value={sede.id}>{sede.nombre}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label>Tipo Factura</label>
                                                <select
                                                    className="form-control"
                                                    value={tipoFacturaFiltro}
                                                    onChange={(e) => setTipoFacturaFiltro(e.target.value)}
                                                >
                                                    <option value="">Todas</option>
                                                    <option value="electronica">Electrónica</option>
                                                    <option value="no_electronica">No Electrónica</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label>Buscar Paciente</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Nombre del paciente..."
                                                    value={busquedaPaciente}
                                                    onChange={(e) => setBusquedaPaciente(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Barra de acciones */}
                            {facturaSeleccionadaId && (
                                <div className="card card-primary card-outline shadow-sm">
                                    <div className="card-header bg-gradient-light">
                                        <div className="d-flex justify-content-between align-items-center flex-wrap">
                                            <div className="d-flex align-items-center flex-wrap">
                                                <h5 className="mb-0 mr-3">
                                                    <i className="fas fa-check-circle text-success"></i>
                                                    <strong>Factura N° {getFacturaSeleccionada()?.numero_factura || `#${getFacturaSeleccionada()?.id}`}</strong>
                                                </h5>
                                                <div className="d-flex flex-wrap">
                                                    <span className="mr-2 mb-1">
                                                        <span className={`badge badge-lg ${getEstadoColor(getFacturaSeleccionada()?.estado)}`}>
                                                            {getEstadoTexto(getFacturaSeleccionada()?.estado)}
                                                        </span>
                                                    </span>
                                                    <span className="mr-2 mb-1">
                                                        <span className={`badge badge-lg ${getFacturaSeleccionada()?.tipo_factura === 'no_electronica' ||
                                                            [4, 5].includes(getFacturaSeleccionada()?.estado)
                                                            ? 'badge-outline-secondary'
                                                            : 'badge-outline-info'
                                                            }`} style={{
                                                                borderColor: getFacturaSeleccionada()?.tipo_factura === 'no_electronica' || [4, 5].includes(getFacturaSeleccionada()?.estado) ? '#6c757d' : '#17a2b8',
                                                                color: getFacturaSeleccionada()?.tipo_factura === 'no_electronica' || [4, 5].includes(getFacturaSeleccionada()?.estado) ? '#6c757d' : '#17a2b8'
                                                            }}>
                                                            <i className={`fas ${getFacturaSeleccionada()?.tipo_factura === 'no_electronica' ||
                                                                [4, 5].includes(getFacturaSeleccionada()?.estado)
                                                                ? 'fa-file-alt'
                                                                : 'fa-bolt'
                                                                } mr-1`}></i>
                                                            {
                                                                getFacturaSeleccionada()?.tipo_factura === 'no_electronica' ||
                                                                    [4, 5].includes(getFacturaSeleccionada()?.estado)
                                                                    ? 'No Electrónica'
                                                                    : 'Electrónica'
                                                            }
                                                        </span>
                                                    </span>
                                                    {(getFacturaSeleccionada()?.estado === 2 || getFacturaSeleccionada()?.estado === 5) && (
                                                        <span className="mb-1">
                                                            <span className="badge badge-lg badge-outline-danger" style={{ borderColor: '#dc3545', color: '#dc3545' }}>
                                                                <i className="fas fa-exclamation-triangle mr-1"></i>
                                                                Pendiente: ${Math.round(parseFloat(getFacturaSeleccionada()?.valor_pendiente || getFacturaSeleccionada()?.valor_total || 0)).toLocaleString('es-CO')}
                                                            </span>
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                            <button
                                                className="btn btn-sm btn-outline-secondary mt-2 mt-md-0"
                                                onClick={() => setFacturaSeleccionadaId(null)}
                                            >
                                                <i className="fas fa-times"></i> Deseleccionar
                                            </button>
                                        </div>
                                    </div>
                                    <div className="card-body py-3">
                                        <div className="btn-toolbar" role="toolbar">
                                            {/* Botón Información - Siempre visible */}
                                            <div className="btn-group mr-2 mb-2" role="group">
                                                <Link
                                                    to={`/informacion-factura/${facturaSeleccionadaId}`}
                                                    className="btn btn-info"
                                                    title="Ver Información Completa"
                                                >
                                                    <i className="fas fa-info-circle"></i> Información
                                                </Link>
                                            </div>

                                            {/* Estado 0: Generada - Anular, Enviar DIAN */}
                                            {getFacturaSeleccionada()?.estado === 0 && (
                                                <>
                                                    {tienePermiso('anular_facturas') && (
                                                        <div className="btn-group mr-2 mb-2" role="group">
                                                            <button
                                                                className="btn btn-outline-danger"
                                                                onClick={() => anularFactura(facturaSeleccionadaId)}
                                                                title="Anular Factura"
                                                            >
                                                                <i className="fas fa-ban"></i> Anular
                                                            </button>
                                                        </div>
                                                    )}
                                                    <div className="btn-group mr-2 mb-2" role="group">
                                                        <button
                                                            className="btn btn-primary"
                                                            onClick={() => reenviarFacturaDian(facturaSeleccionadaId)}
                                                            title="Enviar a la DIAN"
                                                        >
                                                            <i className="fas fa-paper-plane"></i> Enviar a DIAN
                                                        </button>
                                                    </div>
                                                </>
                                            )}

                                            {/* Estado 1: Cobrada - Nota Crédito */}
                                            {getFacturaSeleccionada()?.estado === 1 && (
                                                <div className="btn-group mr-2 mb-2" role="group">
                                                    <button
                                                        className="btn btn-outline-danger"
                                                        onClick={() => abrirModalNotaCredito(getFacturaSeleccionada())}
                                                        title="Generar Nota Crédito"
                                                    >
                                                        <i className="fas fa-file-invoice"></i> Nota Crédito
                                                    </button>
                                                </div>
                                            )}

                                            {/* Estado 2: Por Cobrar (Electrónica) - Nota Crédito, Registrar Pago, Recibos */}
                                            {getFacturaSeleccionada()?.estado === 2 && (
                                                <>
                                                    <div className="btn-group mr-2 mb-2" role="group">
                                                        <button
                                                            className="btn btn-outline-danger"
                                                            onClick={() => abrirModalNotaCredito(getFacturaSeleccionada())}
                                                            title="Generar Nota Crédito"
                                                        >
                                                            <i className="fas fa-file-invoice"></i> Nota Crédito
                                                        </button>
                                                    </div>
                                                    <div className="btn-group mr-2 mb-2" role="group">
                                                        <button
                                                            className="btn btn-primary"
                                                            onClick={() => abrirModalRecibo(getFacturaSeleccionada())}
                                                            title="Registrar Abono"
                                                        >
                                                            <i className="fas fa-money-bill-wave"></i> Registrar Abono
                                                        </button>
                                                        <button
                                                            className="btn btn-primary"
                                                            onClick={() => verRecibos(getFacturaSeleccionada())}
                                                            title="Ver Recibos de Caja"
                                                        >
                                                            <i className="fas fa-receipt"></i> Ver Recibos de Caja
                                                            {recibosFactura.length > 0 && (
                                                                <span className="badge badge-light ml-1">{recibosFactura.length}</span>
                                                            )}
                                                        </button>
                                                    </div>
                                                </>
                                            )}

                                            {/* Estado 3: Anulada - Solo Información (ya mostrada arriba) */}

                                            {/* Estado 4: Cobrada (No Electrónica CONTADO) - Solo Anular */}
                                            {getFacturaSeleccionada()?.estado === 4 && (
                                                <>
                                                    {tienePermiso('anular_facturas') && (
                                                        <div className="btn-group mr-2 mb-2" role="group">
                                                            <button
                                                                className="btn btn-outline-danger"
                                                                onClick={() => anularFactura(facturaSeleccionadaId)}
                                                                title="Anular Factura No Electrónica (Contado - Anulación Total)"
                                                            >
                                                                <i className="fas fa-ban"></i> Anular
                                                            </button>
                                                        </div>
                                                    )}
                                                </>
                                            )}

                                            {/* Estado 5: Por Cobrar (No Electrónica CRÉDITO) - Nota Crédito, Registrar Pago, Recibos */}
                                            {/* ⚠️ IMPORTANTE: Estado 5 NO tiene botón "Anular" independiente */}
                                            {/* El usuario decide en el modal de NC si es total o parcial */}
                                            {getFacturaSeleccionada()?.estado === 5 && (
                                                <>
                                                    <div className="btn-group mr-2 mb-2" role="group">
                                                        <button
                                                            className="btn btn-outline-danger"
                                                            onClick={() => abrirModalNotaCreditoNoElectronica(getFacturaSeleccionada())}
                                                            title="Generar Nota Crédito (solo contra saldo pendiente, NO reversible)"
                                                        >
                                                            <i className="fas fa-file-invoice-dollar"></i> Nota Crédito
                                                        </button>
                                                    </div>
                                                    <div className="btn-group mr-2 mb-2" role="group">
                                                        <button
                                                            className="btn btn-primary"
                                                            onClick={() => abrirModalRecibo(getFacturaSeleccionada())}
                                                            title="Registrar Recibo de Caja (reversible mediante anulación de recibo)"
                                                        >
                                                            <i className="fas fa-money-bill-wave"></i> Registrar Abono
                                                        </button>
                                                        <button
                                                            className="btn btn-primary"
                                                            onClick={() => verRecibos(getFacturaSeleccionada())}
                                                            title="Ver Recibos de Caja (pueden anularse si hay error)"
                                                        >
                                                            <i className="fas fa-receipt"></i> Ver Abonos
                                                            {recibosFactura.length > 0 && (
                                                                <span className="badge badge-light ml-1">{recibosFactura.length}</span>
                                                            )}
                                                        </button>
                                                    </div>
                                                </>
                                            )}

                                            {/* Estado 6: Error DIAN - Anular, Enviar DIAN, Comprobar Estado */}
                                            {getFacturaSeleccionada()?.estado === 6 && (
                                                <>
                                                    {tienePermiso('anular_facturas') && (
                                                        <div className="btn-group mr-2 mb-2" role="group">
                                                            <button
                                                                className="btn btn-outline-danger"
                                                                onClick={() => anularFactura(facturaSeleccionadaId)}
                                                                title="Anular Factura"
                                                            >
                                                                <i className="fas fa-ban"></i> Anular
                                                            </button>
                                                        </div>
                                                    )}
                                                    <div className="btn-group mr-2 mb-2" role="group">
                                                        <button
                                                            className="btn btn-primary"
                                                            onClick={() => reenviarFacturaDian(facturaSeleccionadaId)}
                                                            title="Reintentar envío a la DIAN"
                                                        >
                                                            <i className="fas fa-redo"></i> Enviar a DIAN
                                                        </button>
                                                        <button
                                                            className="btn btn-primary"
                                                            onClick={() => alert('Funcionalidad en desarrollo')}
                                                            title="Comprobar Estado en DIAN"
                                                        >
                                                            <i className="fas fa-search"></i> Comprobar Estado
                                                        </button>
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Tabla de facturas */}
                            <div className="card card-info card-outline">
                                <div className="card-body p-0" style={{ overflowX: 'auto' }}>
                                    <table className="table table-bordered table-hover" style={{ marginBottom: 0 }}>
                                        <thead>
                                            <tr>
                                                <th width="30"></th>
                                                <th>N° Factura</th>
                                                <th>Fecha</th>
                                                <th>Paciente</th>
                                                <th>Profesional</th>
                                                <th>Total</th>
                                                <th>Por Cobrar</th>
                                                <th>Tipo</th>
                                                <th>DIAN</th>
                                                <th>Estado</th>
                                                <th width="150">Acciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {facturasPaginadas.map(factura => (
                                                <tr
                                                    key={factura.id}
                                                    className={facturaSeleccionadaId === factura.id ? 'table-info' : ''}
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => handleSeleccionFactura(factura.id)}
                                                >
                                                    <td className="text-center">
                                                        <input
                                                            type="radio"
                                                            name="facturaSeleccionada"
                                                            checked={facturaSeleccionadaId === factura.id}
                                                            onChange={() => handleSeleccionFactura(factura.id)}
                                                            onClick={(e) => e.stopPropagation()}
                                                        />
                                                    </td>
                                                    <td>
                                                        {(factura.tipo_factura === 'electronica' || [0, 1, 2, 3].includes(factura.estado)) && factura.prefijo && factura.numero_factura ? (
                                                            <strong>{factura.prefijo}-{factura.numero_factura}</strong>
                                                        ) : factura.numero_factura ? (
                                                            <strong>{factura.numero_factura}</strong>
                                                        ) : (
                                                            <strong className="text-muted">#{factura.id}</strong>
                                                        )}
                                                    </td>
                                                    <td>{new Date(factura.fecha_emision).toLocaleDateString()}</td>
                                                    <td>
                                                        <span title={getNombrePaciente(factura.paciente_id)}>
                                                            {getNombrePaciente(factura.paciente_id).length > 25
                                                                ? getNombrePaciente(factura.paciente_id).substring(0, 25) + '...'
                                                                : getNombrePaciente(factura.paciente_id)
                                                            }
                                                        </span>
                                                    </td>
                                                    <td>{getNombreUsuario(factura.users_id)}</td>
                                                    <td className="text-right">
                                                        <strong>${Math.round(parseFloat(factura.valor_total)).toLocaleString('es-CO')}</strong>
                                                    </td>
                                                    <td className="text-right">
                                                        {(factura.estado === 2 || factura.estado === 5) ? (
                                                            <span className="text-danger font-weight-bold">
                                                                ${Math.round(parseFloat(factura.valor_pendiente || factura.valor_total)).toLocaleString('es-CO')}
                                                            </span>
                                                        ) : (
                                                            <span className="text-success">$0</span>
                                                        )}
                                                    </td>
                                                    <td className="text-center">
                                                        <span className="badge badge-outline" style={{
                                                            borderColor: factura.tipo_factura === 'no_electronica' || [4, 5].includes(factura.estado) ? '#6c757d' : '#17a2b8',
                                                            color: factura.tipo_factura === 'no_electronica' || [4, 5].includes(factura.estado) ? '#6c757d' : '#17a2b8',
                                                            borderWidth: '1px',
                                                            borderStyle: 'solid'
                                                        }}>
                                                            <i className={`fas ${factura.tipo_factura === 'no_electronica' || [4, 5].includes(factura.estado)
                                                                ? 'fa-file-alt'
                                                                : 'fa-bolt'
                                                                } mr-1`}></i>
                                                            {
                                                                factura.tipo_factura === 'no_electronica' || [4, 5].includes(factura.estado)
                                                                    ? 'No Elect.'
                                                                    : 'Elect.'
                                                            }
                                                        </span>
                                                    </td>
                                                    <td className="text-center">
                                                        <span className={`badge ${[1, 2, 3].includes(factura.estado) ? 'badge-outline-success' : [4, 5].includes(factura.estado) ? 'badge-outline-secondary' : 'badge-outline-secondary'}`}>
                                                            {[1, 2, 3].includes(factura.estado) ? 'ENVIADO' : [4, 5].includes(factura.estado) ? 'NO APLICA' : 'NO ENVIADO'}
                                                        </span>
                                                    </td>
                                                    <td className="text-center">
                                                        <span className={`badge ${getEstadoColor(factura.estado)}`}>
                                                            {getEstadoTexto(factura.estado)}
                                                        </span>
                                                    </td>
                                                    <td className="text-center">
                                                        <div className="btn-group btn-group-sm" role="group">
                                                            {factura.estado === 7 && (
                                                                <button
                                                                    className="btn btn-primary"
                                                                    onClick={(e) => { e.stopPropagation(); abrirCompletarDatos(factura.id); }}
                                                                    title="Completar datos"
                                                                >
                                                                    <i className="fas fa-edit"></i> Completar datos
                                                                </button>
                                                            )}
                                                            {factura.estado !== 7 && (
                                                                <>
                                                                    <button
                                                                        className="btn btn-info"
                                                                        onClick={(e) => { e.stopPropagation(); vistaPrevia(factura.id); }}
                                                                        title="Vista Previa"
                                                                    >
                                                                        <i className="fas fa-eye"></i>
                                                                    </button>
                                                                    {(factura.estado === 2 || factura.estado === 5) && (
                                                                        <button
                                                                            className="btn btn-primary"
                                                                            onClick={(e) => { e.stopPropagation(); abrirModalRecibo(factura); }}
                                                                            title="Registrar Recibo de Caja"
                                                                        >
                                                                            <i className="fas fa-money-bill-wave"></i>
                                                                        </button>
                                                                    )}
                                                                </>
                                                            )}
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    {facturas.length === 0 && (
                                        <div className="text-center p-4">
                                            <p>No se encontraron facturas para los filtros seleccionados.</p>
                                        </div>
                                    )}
                                </div>

                                {/* Paginador */}
                                {facturas.length > registrosPorPagina && (
                                    <div className="card-footer clearfix">
                                        <div className="row align-items-center">
                                            <div className="col-md-6">
                                                <p className="mb-0">
                                                    Mostrando {indicePrimerRegistro + 1} a {Math.min(indiceUltimoRegistro, facturas.length)} de {facturas.length} registros
                                                </p>
                                            </div>
                                            <div className="col-md-6">
                                                <ul className="pagination pagination-sm m-0 float-right">
                                                    <li className={`page-item ${paginaActual === 1 ? 'disabled' : ''}`}>
                                                        <button
                                                            className="page-link"
                                                            onClick={() => cambiarPagina(paginaActual - 1)}
                                                            disabled={paginaActual === 1}
                                                        >
                                                            «
                                                        </button>
                                                    </li>

                                                    {[...Array(totalPaginas)].map((_, index) => {
                                                        const numeroPagina = index + 1;
                                                        // Mostrar solo 5 páginas a la vez
                                                        if (
                                                            numeroPagina === 1 ||
                                                            numeroPagina === totalPaginas ||
                                                            (numeroPagina >= paginaActual - 1 && numeroPagina <= paginaActual + 1)
                                                        ) {
                                                            return (
                                                                <li
                                                                    key={numeroPagina}
                                                                    className={`page-item ${paginaActual === numeroPagina ? 'active' : ''}`}
                                                                >
                                                                    <button
                                                                        className="page-link"
                                                                        onClick={() => cambiarPagina(numeroPagina)}
                                                                    >
                                                                        {numeroPagina}
                                                                    </button>
                                                                </li>
                                                            );
                                                        } else if (
                                                            numeroPagina === paginaActual - 2 ||
                                                            numeroPagina === paginaActual + 2
                                                        ) {
                                                            return <li key={numeroPagina} className="page-item disabled"><span className="page-link">...</span></li>;
                                                        }
                                                        return null;
                                                    })}

                                                    <li className={`page-item ${paginaActual === totalPaginas ? 'disabled' : ''}`}>
                                                        <button
                                                            className="page-link"
                                                            onClick={() => cambiarPagina(paginaActual + 1)}
                                                            disabled={paginaActual === totalPaginas}
                                                        >
                                                            »
                                                        </button>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>

                        </div>
                    </section>
                </div>

                {/* Modal Recibo de Caja */}
                {showModalRecibo && (
                    <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1">
                        <div className="modal-dialog modal-dialog-scrollable">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h4 className="modal-title">Registrar Recibo de Caja</h4>
                                    <button type="button" className="close" onClick={() => setShowModalRecibo(false)}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="form-group">
                                        <label>Factura N°:</label>
                                        <input type="text" className="form-control" value={facturaSeleccionada?.numero_factura || ''} readOnly />
                                    </div>
                                    <div className="form-group">
                                        <label>Paciente:</label>
                                        <input type="text" className="form-control" value={getNombrePaciente(facturaSeleccionada?.paciente_id)} readOnly />
                                    </div>
                                    <div className="form-group">
                                        <label>Saldo Pendiente:</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={`$${Math.round(parseFloat(facturaSeleccionada?.valor_pendiente || facturaSeleccionada?.valor_total || 0)).toLocaleString('es-CO')}`}
                                            readOnly
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label>Valor a Recibir *:</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            value={valorRecibo}
                                            onChange={(e) => setValorRecibo(e.target.value)}
                                            step="0.01"
                                            min="0.01"
                                            max={facturaSeleccionada?.valor_pendiente || facturaSeleccionada?.valor_total || 0}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label>Fecha de Pago *:</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            value={fechaPago}
                                            onChange={(e) => setFechaPago(e.target.value)}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label>Medio de Pago *:</label>
                                        <select
                                            className="form-control"
                                            value={medioPago}
                                            onChange={(e) => setMedioPago(e.target.value)}
                                        >
                                            <option value="10">Efectivo</option>
                                            <option value="42">Consignación bancaria</option>
                                            <option value="1">Instrumento no definido</option>
                                            <option value="20">Cheque</option>
                                            <option value="30">Transferencia Crédito</option>
                                            <option value="31">Transferencia Débito</option>
                                            <option value="45">Transferencia Crédito Bancario</option>
                                            <option value="47">Transferencia Débito Bancaria</option>
                                            <option value="48">Tarjeta Crédito</option>
                                            <option value="49">Tarjeta Débito</option>
                                            <option value="ZZZ">Acuerdo mutuo</option>
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label>Observaciones:</label>
                                        <textarea
                                            className="form-control"
                                            rows="3"
                                            value={observacionesRecibo}
                                            onChange={(e) => setObservacionesRecibo(e.target.value)}
                                            placeholder="Observaciones del recibo..."
                                        ></textarea>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={() => setShowModalRecibo(false)}>Cancelar</button>
                                    <button type="button" className="btn btn-info" onClick={guardarRecibo}>Guardar Recibo</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Modal Ver Recibos */}
                {showModalRecibos && (
                    <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1">
                        <div className="modal-dialog modal-lg modal-dialog-scrollable">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h4 className="modal-title">Recibos de Caja - Factura N° {facturaSeleccionada?.numero_factura}</h4>
                                    <button type="button" className="close" onClick={() => setShowModalRecibos(false)}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    {recibosFactura.length > 0 ? (
                                        <div className="table-responsive">
                                            <table className="table table-bordered table-hover">
                                                <thead>
                                                    <tr>
                                                        <th>N° Recibo</th>
                                                        <th>Fecha Pago</th>
                                                        <th>Valor</th>
                                                        <th>Medio Pago</th>
                                                        <th>Estado</th>
                                                        <th>Acciones</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {recibosFactura.map(recibo => (
                                                        <tr key={recibo.id}>
                                                            <td>{recibo.numero_recibo}</td>
                                                            <td>{new Date(recibo.fecha_pago).toLocaleDateString()}</td>
                                                            <td>${Math.round(parseFloat(recibo.valor_pago)).toLocaleString('es-CO')}</td>
                                                            <td>{getMedioPagoTexto(recibo.forma_pago)}</td>
                                                            <td>
                                                                <span className={`badge ${recibo.estado === 0 ? 'badge-danger' : 'badge-success'}`}>
                                                                    {recibo.estado === 0 ? 'Anulado' : 'Activo'}
                                                                </span>
                                                            </td>
                                                            <td>
                                                                <button
                                                                    className="btn btn-sm btn-info mr-1"
                                                                    onClick={() => vistaPreviaRecibo(recibo)}
                                                                    title="Vista Previa Recibo"
                                                                >
                                                                    <i className="fas fa-eye"></i>
                                                                </button>
                                                                {recibo.estado !== 0 && (
                                                                    <button
                                                                        className="btn btn-sm btn-danger"
                                                                        onClick={() => anularRecibo(recibo.id)}
                                                                        title="Anular Recibo"
                                                                    >
                                                                        <i className="fas fa-ban"></i>
                                                                    </button>
                                                                )}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    ) : (
                                        <div className="text-center p-4">
                                            <p>No se encontraron recibos para esta factura.</p>
                                        </div>
                                    )}
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-info" onClick={vistaPreviaRecibos}>
                                        <i className="fas fa-print"></i> Vista Previa / Imprimir
                                    </button>
                                    <button type="button" className="btn btn-secondary" onClick={() => setShowModalRecibos(false)}>Cerrar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Modal Nota Crédito */}
                {/* Modal Nota Crédito Electrónica */}
                {showModalNotaCredito && (
                    <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1">
                        <div className="modal-dialog modal-lg">
                            <div className="modal-content">
                                <div className="modal-header bg-info">
                                    <h4 className="modal-title">Generar Nota Crédito Electrónica</h4>
                                    <button type="button" className="close" onClick={() => setShowModalNotaCredito(false)}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <table className="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>Factura</th>
                                                        <th>Paciente</th>
                                                        <th>Valor Total</th>
                                                        <th>Saldo Pendiente</th>
                                                        <th>Fecha</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>{facturaSeleccionada?.numero_factura}</td>
                                                        <td>{getNombrePaciente(facturaSeleccionada?.paciente_id)}</td>
                                                        <td>${Math.round(parseFloat(facturaSeleccionada?.valor_total || 0)).toLocaleString('es-CO')}</td>
                                                        <td className="text-danger font-weight-bold">${Math.round(parseFloat(facturaSeleccionada?.valor_pendiente || facturaSeleccionada?.valor_total || 0)).toLocaleString('es-CO')}</td>
                                                        <td>{facturaSeleccionada ? new Date(facturaSeleccionada.fecha_emision).toLocaleDateString() : ''}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label>Prefijo *</label>
                                                <select
                                                    className="form-control"
                                                    value={prefijoSeleccionado}
                                                    onChange={handlePrefijoChange}
                                                    required
                                                >
                                                    <option value="">Seleccionar...</option>
                                                    {prefijos.map(prefijo => (
                                                        <option key={prefijo.id} value={prefijo.id}>
                                                            {prefijo.prefijo}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label>N° Nota Crédito *</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={numeroNotaCredito}
                                                    readOnly
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label>Fecha Nota Crédito *</label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    value={fechaNotaCredito}
                                                    onChange={(e) => setFechaNotaCredito(e.target.value)}
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>Tipo de Nota Crédito *</label>
                                                <select
                                                    className="form-control"
                                                    value={tipoNotaCredito}
                                                    onChange={(e) => {
                                                        const nuevoTipo = e.target.value;
                                                        setTipoNotaCredito(nuevoTipo);
                                                        if (nuevoTipo === 'total') {
                                                            const saldo = parseFloat(facturaSeleccionada?.valor_pendiente || facturaSeleccionada?.valor_total);
                                                            setValorNotaCredito(saldo);
                                                        } else {
                                                            setValorNotaCredito('');
                                                        }
                                                    }}
                                                >
                                                    <option value="total">Total (Anular Saldo Restante)</option>
                                                    <option value="parcial">Parcial (Ajuste de Valor)</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>Valor a Acreditar *</label>
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text">$</span>
                                                    </div>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        value={valorNotaCredito}
                                                        onChange={(e) => setValorNotaCredito(e.target.value)}
                                                        readOnly={tipoNotaCredito === 'total'}
                                                        max={facturaSeleccionada?.valor_pendiente || facturaSeleccionada?.valor_total}
                                                        required
                                                    />
                                                </div>
                                                {tipoNotaCredito === 'parcial' && (
                                                    <small className="form-text text-muted">Ingresa el valor que deseas descontar del saldo.</small>
                                                )}
                                                {tipoNotaCredito === 'total' && (
                                                    <small className="form-text text-info">Se acreditará el saldo pendiente completo.</small>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <label>Motivo *</label>
                                                <textarea
                                                    className="form-control"
                                                    rows="3"
                                                    value={motivoNotaCredito}
                                                    onChange={(e) => setMotivoNotaCredito(e.target.value)}
                                                    placeholder="Describa la razón de la nota crédito..."
                                                    required
                                                ></textarea>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={() => setShowModalNotaCredito(false)}>Cancelar</button>
                                    <button type="button" className="btn btn-primary" onClick={generarNotaCredito}>
                                        <i className="fas fa-paper-plane"></i> Generar y Enviar a DIAN
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Modal Debug - Mostrar respuesta DIAN */}
                {showModalDebug && (
                    <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1">
                        <div className="modal-dialog modal-xl modal-dialog-scrollable">
                            <div className="modal-content">
                                <div className={`modal-header ${debugType === 'success' ? 'bg-success' : debugType === 'json' ? 'bg-primary' : 'bg-danger'} text-white`}>
                                    <h4 className="modal-title">
                                        {debugType === 'success' ? (
                                            <><i className="fas fa-check-circle mr-2"></i>Envío Exitoso</>
                                        ) : debugType === 'json' ? (
                                            <><i className="fas fa-code mr-2"></i>JSON para DIAN</>
                                        ) : (
                                            <><i className="fas fa-exclamation-triangle mr-2"></i>Error en el Envío</>
                                        )}
                                    </h4>
                                    <button type="button" className="close text-white" onClick={() => setShowModalDebug(false)}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    {debugType === 'json' ? (
                                        <div>
                                            <div className="alert alert-info">
                                                <h5><i className="fas fa-code"></i> {debugData?.message}</h5>
                                                {debugData?.subtitle && <small>{debugData.subtitle}</small>}
                                            </div>
                                            <div className="card">
                                                <div className="card-header bg-light">
                                                    <strong>JSON</strong>
                                                </div>
                                                <div className="card-body">
                                                    <pre style={{
                                                        backgroundColor: '#f8f9fa',
                                                        padding: '15px',
                                                        borderRadius: '4px',
                                                        maxHeight: '500px',
                                                        overflow: 'auto',
                                                        fontSize: '12px',
                                                        whiteSpace: 'pre-wrap',
                                                        wordWrap: 'break-word'
                                                    }}>{JSON.stringify(debugData?.json, null, 2)}</pre>
                                                </div>
                                            </div>
                                        </div>
                                    ) : debugType === 'success' ? (
                                        <div>
                                            <div className="alert alert-info">
                                                <h5><i className="fas fa-check-circle"></i> {debugData?.message}</h5>
                                            </div>
                                            <div className="card border-success">
                                                <div className="card-header bg-success text-white">
                                                    <strong><i className="fas fa-check-circle mr-2"></i>Detalles de la Respuesta</strong>
                                                </div>
                                                <div className="card-body">
                                                    <p><strong>CUFE:</strong> <code style={{ fontSize: '0.9em' }}>{debugData?.cufe}</code></p>
                                                    {debugData?.numero_nc ? (
                                                        <>
                                                            <p><strong>Número Nota Crédito:</strong>
                                                                <span className="badge badge-success ml-2">{debugData.numero_nc}</span>
                                                            </p>
                                                            {debugData?.recibos_anulados > 0 && (
                                                                <p><strong>Recibos Anulados:</strong>
                                                                    <span className="badge badge-warning ml-2">{debugData.recibos_anulados}</span>
                                                                </p>
                                                            )}
                                                        </>
                                                    ) : (
                                                        <p><strong>Estado de la Factura:</strong>
                                                            <span className={`badge ml-2 ${debugData?.estado === 1 ? 'badge-success' : 'badge-info'}`}>
                                                                {debugData?.estado === 1 ? 'Cobrada (Contado)' : 'Por Cobrar (Crédito)'}
                                                            </span>
                                                        </p>
                                                    )}
                                                </div>
                                            </div>
                                            {debugData?.facturaId && (
                                                <div className="mt-3">
                                                    <button
                                                        className="btn btn-outline-info mr-2"
                                                        onClick={() => verJsonPreview(debugData.facturaId)}
                                                    >
                                                        <i className="fas fa-code"></i> Ver JSON enviado
                                                    </button>
                                                    <button
                                                        className="btn btn-info mr-2"
                                                        onClick={() => window.location.href = `/#/informacion-factura/${debugData.facturaId}`}
                                                    >
                                                        <i className="fas fa-info-circle"></i> Ver Detalles de Factura
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    ) : (
                                        <div>
                                            <div className="alert alert-danger">
                                                <h5><i className="fas fa-exclamation-triangle"></i> {debugData?.message}</h5>
                                            </div>

                                            {debugData?.response && (
                                                <div className="card mb-3">
                                                    <div className="card-header bg-warning">
                                                        <strong><i className="fas fa-exclamation-triangle mr-2"></i>Respuesta de la DIAN</strong>
                                                    </div>
                                                    <div className="card-body">
                                                        <pre style={{
                                                            backgroundColor: '#f8f9fa',
                                                            padding: '15px',
                                                            borderRadius: '4px',
                                                            maxHeight: '400px',
                                                            overflow: 'auto',
                                                            fontSize: '12px',
                                                            whiteSpace: 'pre-wrap',
                                                            wordWrap: 'break-word'
                                                        }}>{JSON.stringify(debugData.response, null, 2)}</pre>
                                                    </div>
                                                </div>
                                            )}

                                            {debugData?.json_enviado && (
                                                <div className="card mb-3">
                                                    <div className="card-header bg-primary text-white">
                                                        <strong><i className="fas fa-code mr-2"></i>JSON Enviado a la DIAN</strong>
                                                    </div>
                                                    <div className="card-body">
                                                        <pre style={{
                                                            backgroundColor: '#f8f9fa',
                                                            padding: '15px',
                                                            borderRadius: '4px',
                                                            maxHeight: '400px',
                                                            overflow: 'auto',
                                                            fontSize: '12px',
                                                            whiteSpace: 'pre-wrap',
                                                            wordWrap: 'break-word'
                                                        }}>{JSON.stringify(debugData.json_enviado, null, 2)}</pre>
                                                    </div>
                                                </div>
                                            )}

                                            {/* Botones de navegación */}
                                            {debugData?.facturaId && (
                                                <div className="mt-3">
                                                    <button
                                                        className="btn btn-info mr-2"
                                                        onClick={() => window.location.href = `/#/informacion-factura/${debugData.facturaId}`}
                                                    >
                                                        <i className="fas fa-info-circle"></i> Ver Detalles de Factura
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={() => setShowModalDebug(false)}>
                                        Cerrar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Modal Nota Crédito No Electrónica */}
                {showModalNotaCreditoNE && consecutivoNCNE && (
                    <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1" role="dialog">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-header bg-danger text-white">
                                    <h5 className="modal-title">
                                        <i className="fas fa-file-invoice-dollar"></i> Generar Nota Crédito
                                    </h5>
                                    <button type="button" className="close text-white" onClick={() => setShowModalNotaCreditoNE(false)}>
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <form onSubmit={generarNotaCreditoNE}>
                                    <div className="modal-body">
                                        <div className="alert alert-info py-2">
                                            <small><i className="fas fa-info-circle"></i> <strong>Factura Afectada:</strong> {facturaSeleccionada?.prefijo ? `${facturaSeleccionada.prefijo}-` : ''}{facturaSeleccionada?.numero_factura}</small><br />
                                            <small><i className="fas fa-wallet"></i> <strong>Saldo Pendiente:</strong> ${Math.round(facturaSeleccionada?.valor_pendiente || facturaSeleccionada?.valor_total).toLocaleString()}</small>
                                        </div>

                                        <div className="form-group row">
                                            <label className="col-sm-4 col-form-label">Consecutivo:</label>
                                            <div className="col-sm-8">
                                                <input
                                                    type="text"
                                                    className="form-control-plaintext font-weight-bold"
                                                    value={`${consecutivoNCNE.prefijo || ''}-${consecutivoNCNE.consecutivo || ''}`}
                                                    readOnly
                                                />
                                            </div>
                                        </div>

                                        <div className="form-group">
                                            <label>Tipo de Nota</label>
                                            <select
                                                className="form-control"
                                                value={tipoNotaCreditoNE}
                                                onChange={(e) => {
                                                    const nuevoTipo = e.target.value;
                                                    setTipoNotaCreditoNE(nuevoTipo);
                                                    if (nuevoTipo === 'total') {
                                                        const saldo = parseFloat(facturaSeleccionada?.valor_pendiente || facturaSeleccionada?.valor_total);
                                                        setValorNotaCreditoNE(saldo);
                                                    }
                                                }}
                                            >
                                                <option value="total">Total (Anular Saldo Restante)</option>
                                                <option value="parcial">Parcial (Ajuste de Valor)</option>
                                            </select>
                                        </div>

                                        <div className="form-group">
                                            <label>Valor a Acreditar</label>
                                            <div className="input-group">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text">$</span>
                                                </div>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    value={valorNotaCreditoNE}
                                                    onChange={(e) => setValorNotaCreditoNE(e.target.value)}
                                                    readOnly={tipoNotaCreditoNE === 'total'}
                                                    max={facturaSeleccionada?.valor_pendiente || facturaSeleccionada?.valor_total}
                                                    required
                                                />
                                            </div>
                                            {tipoNotaCreditoNE === 'parcial' && (
                                                <small className="form-text text-muted">Ingresa el valor que deseas descontar del saldo.</small>
                                            )}
                                        </div>

                                        <div className="form-group">
                                            <label>Fecha Emisión</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={fechaNotaCreditoNE}
                                                onChange={(e) => setFechaNotaCreditoNE(e.target.value)}
                                                required
                                            />
                                        </div>

                                        <div className="form-group">
                                            <label>Motivo *</label>
                                            <textarea
                                                className="form-control"
                                                rows="3"
                                                value={motivoNotaCreditoNE}
                                                onChange={(e) => setMotivoNotaCreditoNE(e.target.value)}
                                                placeholder="Describa la razón de la nota crédito..."
                                                required
                                            ></textarea>
                                        </div>
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-secondary" onClick={() => setShowModalNotaCreditoNE(false)}>Cancelar</button>
                                        <button type="submit" className="btn btn-primary" disabled={loadingNCNE}>
                                            {loadingNCNE ? <i className="fas fa-spinner fa-spin"></i> : <i className="fas fa-save"></i>} Generar Nota
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                )}

                {/* Modal Éxito Recibo */}
                {showModalExitoRecibo && reciboGuardado && (
                    <Modal show={showModalExitoRecibo} onHide={() => setShowModalExitoRecibo(false)} centered>
                        <Modal.Header closeButton className="bg-info text-white">
                            <Modal.Title>
                                <i className="fas fa-check-circle"></i> Recibo Registrado Exitosamente
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="text-center mb-3">
                                <i className="fas fa-receipt fa-3x text-success mb-3"></i>
                                <h5>Recibo N° {reciboGuardado.numero_recibo}</h5>
                                <p className="text-muted mb-1">
                                    Valor: <strong>${Math.round(parseFloat(reciboGuardado.valor_pago || reciboGuardado.valor_recibido || valorRecibo)).toLocaleString('es-CO')}</strong>
                                </p>
                                <p className="text-muted">
                                    <small>Factura N° {facturaSeleccionada?.numero_factura}</small>
                                </p>
                            </div>
                            <div className="alert alert-info">
                                <i className="fas fa-info-circle"></i> El recibo ha sido registrado correctamente en el sistema.
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={() => setShowModalExitoRecibo(false)}>
                                Cerrar
                            </Button>
                            <Button 
                                variant="info" 
                                onClick={() => {
                                    vistaPreviaRecibo(reciboGuardado);
                                }}
                            >
                                <i className="fas fa-file-pdf"></i> Ver PDF
                            </Button>
                            <Button 
                                variant="primary" 
                                onClick={() => {
                                    vistaPreviaRecibo(reciboGuardado);
                                    setShowModalExitoRecibo(false);
                                }}
                            >
                                <i className="fas fa-print"></i> Imprimir
                            </Button>
                        </Modal.Footer>
                    </Modal>
                )}

                {/* Modal para completar datos de factura en borrador */}
                <CompletarDatosFactura
                    show={showModalCompletarDatos}
                    facturaId={facturaCompletarId}
                    onComplete={handleCompletarDatosSuccess}
                    onCancel={() => setShowModalCompletarDatos(false)}
                />

                <Footer showToast={false} delay={0} />
            </div>
        );
    }

    // Si no tiene permisos, mostrar página de no autorizado
    if (hasPermission === false) {
        return <Unauthorized />;
    }

    return <Loading />;
}

export default ListadoFacturas;
